import { JsonUtils } from '../../utils/json.util'
import { FatigueAnswer } from '../users/fatigue'
import { NocturnalUrinaryFrequency } from '../../utils/nocturnal.urinary.frequency'
import { ActivityLevelReport } from '../../utils/activity.level.report'

export default class Report {
    private _id: string | undefined
    private _created_at: string | undefined
    private _updated_at: string | undefined
    private _start_date: string | undefined
    private _end_date: string | undefined
    private _activity_level:  ActivityLevelReport | undefined
    private _weight: number | undefined
    private _height: number | undefined
    private _weight_annual_variation: string | undefined
    private _bmi: number | undefined
    private _waist_circumference: number | undefined
    private _calf_circumference: number | undefined
    private _hand_grip: number | undefined
    private _gait_speed: number | undefined
    private _muscle_strength: number | undefined
    private _nocturia:  NocturnalUrinaryFrequency| undefined
    private _depression: number | undefined
    private _daytime_sleepiness: number | undefined
    private _frailty_syndrome: string | undefined
    private _sarcopenia: number | undefined
    private _effort_required: FatigueAnswer | undefined
    private _set_activities_aside: FatigueAnswer | undefined
    private _files: any | undefined
    private _patient_id: string | undefined
    private _download_link: string | undefined

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }

    get created_at(): string | undefined {
        return this._created_at
    }
    set created_at(value: string | undefined) {
        this._created_at = value
    }

    get updated_at(): string | undefined {
        return this._updated_at
    }

    set updated_at(value: string | undefined) {
        this._updated_at = value
    }

    get start_date(): string | undefined {
        return this._start_date
    }

    set start_date(value: string | undefined) {
        this._start_date = value
    }

    get end_date(): string | undefined {
        return this._end_date
    }

    set end_date(value: string | undefined) {
        this._end_date = value
    }

    get activity_level():  ActivityLevelReport | undefined {
        return this._activity_level
    }

    set activity_level(value:  ActivityLevelReport | undefined) {
        this._activity_level = value
    }

    get height(): number | undefined {
        return this._height
    }

    set height(value: number | undefined) {
        this._height = value
    }

    get weight(): number | undefined {
        return this._weight
    }

    set weight(value: number | undefined) {
        this._weight = value
    }

    get weight_annual_variation(): string | undefined {
        return this._weight_annual_variation
    }

    set weight_annual_variation(value: string | undefined) {
        this._weight_annual_variation = value
    }
    get bmi(): number | undefined {
        return this._bmi
    }

    set bmi(value: number | undefined) {
        this._bmi = value
    }

    get waist_circumference(): number | undefined {
        return this._waist_circumference
    }

    set waist_circumference(value: number | undefined) {
        this._waist_circumference = value
    }

    get calf_circumference(): number | undefined {
        return this._calf_circumference
    }

    set calf_circumference(value: number | undefined) {
        this._calf_circumference = value
    }

    get hand_grip(): number | undefined {
        return this._hand_grip
    }

    set hand_grip(value: number | undefined) {
        this._hand_grip = value
    }

    get gait_speed(): number | undefined {
        return this._gait_speed
    }

    set gait_speed(value: number | undefined) {
        this._gait_speed = value
    }

    get muscle_strength(): number | undefined {
        return this._muscle_strength
    }

    set muscle_strength(value: number | undefined) {
        this._muscle_strength = value
    }
    get nocturia():  NocturnalUrinaryFrequency | undefined {
        return this._nocturia
    }

    set nocturia(value:  NocturnalUrinaryFrequency | undefined) {
        this._nocturia = value
    }

    get depression(): number | undefined {
        return this._depression
    }

    set depression(value: number | undefined) {
        this._depression = value
    }

    get daytime_sleepiness(): number | undefined {
        return this._daytime_sleepiness
    }

    set daytime_sleepiness(value: number | undefined) {
        this._daytime_sleepiness = value
    }

    get frailty_syndrome(): string | undefined {
        return this._frailty_syndrome
    }

    set frailty_syndrome(value: string | undefined) {
        this._frailty_syndrome = value
    }

    get sarcopenia(): number | undefined {
        return this._sarcopenia
    }

    set sarcopenia(value: number | undefined) {
        this._sarcopenia = value
    }
    get effort_required(): FatigueAnswer | undefined {
        return this._effort_required
    }

    set effort_required(value: FatigueAnswer | undefined) {
        this._effort_required = value
    }

    get set_activities_aside(): FatigueAnswer | undefined {
        return this._set_activities_aside
    }

    set set_activities_aside(value: FatigueAnswer | undefined) {
        this._set_activities_aside = value
    }

    get files(): any | undefined {
        return this._files
    }

    set files(value: any | undefined) {
        this._files = value
    }

    get patient_id(): string | undefined {
        return this._patient_id
    }
    set patient_id(value: string | undefined) {
        this._patient_id = value
    }

    get download_link(): string | undefined {
        return this._download_link
    }

    set download_link(value: string | undefined) {
        this._download_link = value
    }

    public fromJSON(json: any): Report {
        if (!json) {
            return this
        }

        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.id !== undefined) {
            this.id = json.id
        }

        if (json.created_at !== undefined) {
            this.created_at = json.created_at
        }

        if (json.activity_level !== undefined) {
            this.activity_level = json.activity_level
        }

        if (json.weight !== undefined) {
            this.weight = json.weight
        }

        if (json.height !== undefined) {
            this.height = json.height
        }

        if (json.weight_annual_variation !== undefined) {
            this.weight_annual_variation = json.weight_annual_variation
        }

        if (json.bmi !== undefined) {
            this.bmi = json.bmi
        }

        if (json.waist_circumference !== undefined) {
            this.waist_circumference = json.waist_circumference
        }

        if (json.calf_circumference !== undefined) {
            this.calf_circumference = json.calf_circumference
        }

        if (json.hand_grip !== undefined) {
            this.hand_grip = json.hand_grip
        }

        if (json.gait_speed !== undefined) {
            this.gait_speed = json.gait_speed
        }

        if (json.nocturia !== undefined) {
            this.nocturia = json.nocturia
        }

        if (json.depression !== undefined) {
            this.depression = json.depression
        }

        if (json.daytime_sleepiness !== undefined) {
            this.daytime_sleepiness = json.daytime_sleepiness
        }

        if (json.frailty_syndrome !== undefined) {
            this.frailty_syndrome = json.frailty_syndrome
        }

        if (json.effort_required !== undefined) {
            this.effort_required = json.effort_required
        }

        if (json.effort_required !== undefined) {
            this.effort_required = json.effort_required
        }

        if (json.sarcopenia !== undefined) {
            this.sarcopenia = json.sarcopenia
        }

        if (json.muscle_strength !== undefined) {
            this.muscle_strength = json.muscle_strength
        }

        if (json.start_date !== undefined) {
            this.start_date = json.start_date
        }

        if (json.end_date !== undefined) {
            this.end_date = json.end_date
        }

        if (json.patient_id !== undefined) {
            this.patient_id = json.patient_id
        }

        if (json.download_link !== undefined) {
            this.download_link = json.download_link
        }
        if (json.files !== undefined) {
            this.files = json.files
        }
        return this
    }

    public toJSON(): any {
        return {
            id: this.id || undefined,
            created_at: this.created_at || undefined,
            updated_at: this.updated_at || undefined,
            start_date: this.start_date || undefined,
            end_date: this.end_date || undefined,
            activity_level: this.activity_level || undefined,
            weight: this.weight || undefined,
            height: this.height || undefined,
            weight_annual_variation: this.weight_annual_variation || undefined,
            bmi: this.bmi || undefined,
            waist_circumference: this.waist_circumference || undefined,
            calf_circumference: this.calf_circumference || undefined,
            hand_grip: this.hand_grip || undefined,
            gait_speed: this.gait_speed || undefined,
            muscle_strength: this.muscle_strength || undefined,
            nocturia: this.nocturia || undefined,
            depression: this.depression || undefined,
            daytime_sleepiness: this.daytime_sleepiness || undefined,
            frailty_syndrome: this.frailty_syndrome || undefined,
            sarcopenia: this.sarcopenia || undefined,
            effort_required: this.effort_required || undefined,
            set_activities_aside: this.set_activities_aside || undefined,
            files: this.files || undefined,
            patient_id: this.patient_id || undefined,
            download_link: this.download_link || undefined
        }
    }

}
